import React from 'react';

const InformationByDownloadType = ({type}) => {
	let text = '';
	switch(type.toLowerCase()) {
		case 'webportal':
			text = 'Esta forma de descarga tiene una limitante de 2,000 documentos por día y podrás descargar los comprobantes de inmediato. Selecciona los parámetros de descarga y los reportes de que deseas obtener.';
			break;
		case 'webservice':
			text = 'Esta forma de descarga tiene una limitante de hasta 200,000 registros por vez y el SAT puede demorar hasta 6 días naturales en regresar los registros. Selecciona los parámetros de descarga y los reportes de que deseas obtener.';
			break;
		default:
			break;
	}
	return (
		<div className="download-xmls-container-text">
			{text}	
		</div>
	)
}

export default InformationByDownloadType;